import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import React from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { withRouter, Link } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action

// import images
import logoMark from "../../assets/images/monitorwise-mark-dark.svg";

const ForgetPasswordPage = (props: any) => {
  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: (values) => {
       
    }
  });

  const { forgetError, forgetSuccessMsg } = useSelector((state: any) => ({
    forgetError: state.ForgetPassword.forgetError,
    forgetSuccessMsg: state.ForgetPassword.forgetSuccessMsg,
  }));

  return (
    <React.Fragment>
      <MetaTags>
        <title>Forget Password | Monitorwise</title>
      </MetaTags>
      <div className="mw-auth">
        <div>
          <div className="mw-auth-card">
            <div className="mw-auth-head">
              <div className="mw-auth-logo">
                <img src={logoMark} alt="Monitorwise" height="30" />
                <h4>MonitorWise</h4>
              </div>
              <h5>Reset your password</h5>
              <p>Enter Your Email to Receive Reset Instructions</p>
            </div>
            <div className="mw-auth-body">
              {forgetError && forgetError ? (
                <Alert color="danger">{forgetError}</Alert>
              ) : null}
              {forgetSuccessMsg ? (
                <Alert color="success">{forgetSuccessMsg}</Alert>
              ) : null}

              <Form
                className="form-horizontal"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <div className="mb-3">
                  <Label className="form-label">Email</Label>
                  <div className="mw-input-group">
                    <i className="mdi mdi-email-outline mw-input-icon" />
                    <Input
                      name="email"
                      className="form-control"
                      placeholder="Enter email"
                      type="email"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email || ""}
                      invalid={
                        validation.touched.email && validation.errors.email ? true : false
                      }
                    />
                  </div>
                  {validation.touched.email && validation.errors.email ? (
                    <div className="text-danger small mt-1">{validation.errors.email}</div>
                  ) : null}
                </div>
                <div className="mt-4 d-grid">
                  <button className="btn btn-primary" type="submit">
                    Reset password
                  </button>
                </div>
              </Form>
            </div>
          </div>
          <div className="mw-auth-footer">
            <p className="mb-1">
              Go back to <Link to="/login">Login</Link>
            </p>
            <p className="mb-0" style={{ opacity: 0.6 }}>
              © {new Date().getFullYear()} MonitorWise
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
